import React from 'react';
import A from '@adsk/bim360-matrix-react-a';
import SimpleModal from '@adsk/bim360-matrix-react-simple-modal';
import { MDText } from 'i18n-react';
import { withLocale, TSymbolProp } from '@adsk/bim360-matrix-react-helpers/es/locale';
import { MatrixLaunchDarklyConsumer } from '@adsk/bim360-matrix-react-api/es/contexts/launchDarkly';

const STORAGE_KEY = 'MATRIX_HIDE_IE_MODAL';

export class IENotSupportedModal extends React.Component {
  constructor(props) {
    super(props);

    // detect IE or non-Chromium Edge
    // https://stackoverflow.com/questions/56360225/how-to-detect-microsoft-chromium-edge-chredge-edgium-in-javascript
    const isIEOrOldEdge =
      process.env.NODE_ENV === 'ie_test' || !('reversed' in document.createElement('ol'));

    this.state = {
      show: isIEOrOldEdge && sessionStorage.getItem(STORAGE_KEY) !== 'true'
    };
  }

  render() {
    const { show } = this.state;

    return (
      show && (
        <MatrixLaunchDarklyConsumer flagName="show-matrix-ie-modal">
          {({ value: isIENotSupportedModalFFEnabled }) => (
            <MatrixLaunchDarklyConsumer flagName="matrix-ie-modal-jul-30">
              {({ value: isJul30Enabled }) =>
                isIENotSupportedModalFFEnabled ? (
                  <SimpleModal
                    show={show}
                    modalHeaderProps={{ style: { minHeight: 0 }}}
                    modalBodyProps={{ style: { flex: '1 1 auto' }}}
                    title={this.props[TSymbolProp].translate('INCOMPATIBLE_BROWSER_TITLE')}
                    onHide={() => {
                      sessionStorage.setItem(STORAGE_KEY, 'true');
                      this.setState({
                        show: false
                      });
                    }}
                  >
                    {this.props[TSymbolProp].translate(
                      isJul30Enabled
                        ? 'INCOMPATIBLE_BROWSER_BODY_AFTER_JUL_30'
                        : 'INCOMPATIBLE_BROWSER_BODY',
                      {
                        edge: (
                          <A
                            href="https://www.microsoft.com/en-us/edge"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Edge
                          </A>
                        ),
                        chrome: (
                          <A
                            href="https://www.google.com/chrome/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Chrome
                          </A>
                        ),
                        firefox: (
                          <A
                            href="https://www.mozilla.org/en-US/firefox/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Firefox
                          </A>
                        ),
                        knowledge: (
                          <A
                            href="http://help.autodesk.com/view/BIM360D/ENU/?guid=GUID-FCC9F18A-1CBE-4318-9EEA-2DD826A3D8AE"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {this.props[TSymbolProp].translate('KNOWLEDGE_ARTICLE')}
                          </A>
                        )
                      }
                    )}
                  </SimpleModal>
                ) : null
              }
            </MatrixLaunchDarklyConsumer>
          )}
        </MatrixLaunchDarklyConsumer>
      )
    );
  }
}

IENotSupportedModal.displayName = 'IENotSupportedModal';

export default withLocale(
  IENotSupportedModal,
  ({ locale }) => new MDText(require(`./i18n/${locale}.json`))
);
